
/*
  UXS — INCOMING SIGNAL V8
  DAY2K / UNIDOS X EL SONIDO

  CLEAN UI + ESCRITURA PROGRESIVA + EMAIL GATE

  Conserva:
  - Supabase privado
  - Audio Blob local
  - VOICE001 y riser
  - Alienígena reactivo
  - Transición original
  - Timestamps
  - Subtítulos progresivos
  - Pausa y repetición
  - COMPARTIR / NO COMPARTIR

  Nuevo:
  - Pantalla de correo tras guardar la señal
  - Continuar sin correo
  - VOICE001 V13 después de decidir
*/

(function () {
  "use strict";

  const SUPABASE_URL =
    "https://owwcdrqwfevwbkubrlff.supabase.co";

  const SUPABASE_KEY =
    "sb_publishable_xn5hzUtHdOZNJZ0eRZLr_g_3SmeqUS4";

  const FUNCTION_NAME = "uxs-get-incoming-signal";

  const SUBTITLE_OFFSET = 0;

  function init() {
    const root =
      document.getElementById("uxs-experience");

    const recording =
      document.getElementById("uxs-recording");

    if (!root || !recording) return;
    if (root.dataset.incomingReady) return;

    root.dataset.incomingReady = "v8";

    [
      "uxs-incoming-styles",
      "uxs-incoming-v2-styles",
      "uxs-incoming-v3-styles",
      "uxs-incoming-v4-styles",
      "uxs-incoming-v5-styles",
      "uxs-incoming-v6-styles",
      "uxs-incoming-v7-styles"
    ].forEach(id => {
      document.getElementById(id)?.remove();
    });

    const style = document.createElement("style");
    style.id = "uxs-incoming-v7-styles";

    style.textContent = `
      #uxs-incoming-panel {
        display: none;
        width: min(90vw, 470px);
        max-width: 100%;
        margin: 0 auto 36px;
        padding: 8px 12px;
        box-sizing: border-box;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        color: #fff;
        font-family: monospace;
        text-align: center;
      }

      #uxs-experience.uxs-incoming-stage
      #uxs-incoming-panel {
        display: flex;
      }

      #uxs-experience.uxs-incoming-transitioning
      #uxs-incoming-panel {
        display: none !important;
      }

      #uxs-experience.uxs-incoming-stage
      #uxs-main {
        display: flex !important;
        flex-direction: column;
        align-items: center !important;
        justify-content: center !important;
        width: 100%;
        min-height: 100svh;
        padding: 30px 16px !important;
        box-sizing: border-box;
        overflow-y: auto;
        opacity: 1 !important;
        visibility: visible !important;
        animation: none !important;
      }

      #uxs-experience.uxs-incoming-stage
      #uxs-recording {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: min(90vw, 600px);
        margin: 0 auto !important;
      }

      #uxs-experience.uxs-incoming-stage
      #uxs-share-panel,
      #uxs-experience.uxs-incoming-stage
      #uxs-transcription-panel,
      #uxs-experience.uxs-incoming-stage
      #uxs-audio-interface,
      #uxs-experience.uxs-incoming-stage
      #uxs-record,
      #uxs-experience.uxs-incoming-stage
      #uxs-status,
      #uxs-experience.uxs-incoming-stage
      #uxs-transcript,
      #uxs-experience.uxs-incoming-stage
      #uxs-record-timer,
      #uxs-experience.uxs-incoming-stage
      #uxs-message {
        display: none !important;
      }

      #uxs-incoming-label {
        display: none;
      }

      #uxs-incoming-question {
        max-width: 405px;
        color: #fff;
        font-size: clamp(14px, 3vw, 18px);
        font-weight: 400;
        line-height: 1.85;
        letter-spacing: 1px;
        text-wrap: balance;
      }

      #uxs-incoming-other-question {
        display: none !important;
      }

      #uxs-incoming-play {
        appearance: none;
        display: none;
        align-items: center;
        justify-content: center;
        gap: 12px;
        min-width: 180px;
        min-height: 52px;
        padding: 15px 30px;
        border: 1px solid rgba(255,255,255,.6);
        border-radius: 999px;
        background: transparent;
        color: #fff;
        font: 12px monospace;
        letter-spacing: 1.8px;
        cursor: pointer;
        transition:
          border-color .25s ease,
          background .25s ease;
      }

      #uxs-incoming-play:hover {
        border-color: #fff;
        background: rgba(255,255,255,.07);
      }

      #uxs-incoming-play:disabled {
        opacity: .4;
        cursor: wait;
      }

      #uxs-incoming-transcript {
        display: none;
        box-sizing: border-box;
        width: min(90vw, 420px);
        max-height: min(250px, 35svh);
        min-height: 50px;
        margin: 12px auto 2px;
        padding: 4px 12px;
        overflow-x: hidden;
        overflow-y: auto;
        color: rgba(255,255,255,.82);
        font: 13px/1.95 monospace;
        letter-spacing: .25px;
        text-align: left;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        scrollbar-width: thin;
        scrollbar-color:
          rgba(255,255,255,.2) transparent;
      }

      #uxs-incoming-transcript.uxs-writing {
        display: block;
      }

      #uxs-incoming-status {
        min-height: 18px;
        color: rgba(255,255,255,.45);
        font-size: 10px;
        line-height: 1.9;
        letter-spacing: 1px;
      }

      #uxs-incoming-footer {
        display: none;
      }

      #uxs-incoming-audio {
        display: none;
      }

      @media (max-width: 600px) {
        #uxs-incoming-panel {
          gap: 17px;
        }

        #uxs-incoming-transcript {
          font-size: 12px;
          line-height: 2;
          max-height: 190px;
        }
      }
    `;

    document.head.appendChild(style);

    document.getElementById(
      "uxs-incoming-panel"
    )?.remove();

    const panel = document.createElement("section");
    panel.id = "uxs-incoming-panel";

    panel.innerHTML = `
      <div id="uxs-incoming-label"></div>

      <div id="uxs-incoming-question"></div>

      <div
        id="uxs-incoming-other-question"
        hidden
      ></div>

      <button
        id="uxs-incoming-play"
        type="button"
      >
        <span aria-hidden="true">▶</span>
        <span id="uxs-incoming-play-label">
          ESCUCHAR
        </span>
      </button>

      <div
        id="uxs-incoming-transcript"
        aria-live="off"
      ></div>

      <div
        id="uxs-incoming-status"
        role="status"
        aria-live="polite"
      ></div>

      <div id="uxs-incoming-footer"></div>

      <audio
        id="uxs-incoming-audio"
        preload="auto"
      ></audio>
    `;

    recording.appendChild(panel);

    const label =
      panel.querySelector("#uxs-incoming-label");

    const questionEl =
      panel.querySelector("#uxs-incoming-question");

    const otherQuestionEl =
      panel.querySelector("#uxs-incoming-other-question");

    const playButton =
      panel.querySelector("#uxs-incoming-play");

    const playLabel =
      panel.querySelector("#uxs-incoming-play-label");

    const transcriptEl =
      panel.querySelector("#uxs-incoming-transcript");

    const status =
      panel.querySelector("#uxs-incoming-status");

    const footer =
      panel.querySelector("#uxs-incoming-footer");

    const audio =
      panel.querySelector("#uxs-incoming-audio");

    let client = null;

    let started = false;
    let transitionFinished = false;
    let lookupFinished = false;
    let lookupError = false;

    let currentSignal = null;
    let originalQuestion = "";

    let localAudioURL = null;
    let loadingAudio = null;
    let refreshing = null;

    let timingWords = [];
    let lastSubtitleIndex = -1;

    function emit(name, detail = {}) {
      root.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail
        })
      );
    }

    function setPlayLabel(text) {
      playLabel.textContent = text;
    }

    function getOriginalQuestion() {
      return String(
        window.UXSSession?.deepQuestion || ""
      ).trim();
    }

    function getPath() {
      return String(
        window.UXSSession?.path || ""
      ).trim().toLowerCase();
    }

    function setOtherQuestion(text) {
      otherQuestionEl.hidden = !text;

      otherQuestionEl.textContent =
        text ? "OTRA PREGUNTA: " + text : "";
    }

    function rememberSignal(signal) {
      currentSignal = signal;
    }

    function clearLocalAudio() {
      audio.pause();
      audio.removeAttribute("src");
      audio.load();

      if (localAudioURL) {
        URL.revokeObjectURL(localAudioURL);
        localAudioURL = null;
      }
    }

    function getClient() {
      if (!window.supabase?.createClient) {
        throw new Error("SUPABASE_NOT_LOADED");
      }

      if (!client) {
        client = window.supabase.createClient(
          SUPABASE_URL,
          SUPABASE_KEY,
          {
            auth: {
              persistSession: true,
              autoRefreshToken: true,
              detectSessionInUrl: false
            }
          }
        );
      }

      return client;
    }

    async function ensureSession(supa) {
      const { data, error } =
        await supa.auth.getSession();

      if (error) throw error;

      if (data.session?.access_token) {
        return;
      }

      const result =
        await supa.auth.signInAnonymously();

      if (
        result.error ||
        !result.data.session
      ) {
        throw result.error ||
          new Error("AUTH_FAILED");
      }
    }

    async function requestSignal(signalId = null) {
      const path = getPath();

      const question =
        originalQuestion || getOriginalQuestion();

      if (!path || !question) {
        throw new Error("MISSING_SESSION_QUESTION");
      }

      const supa = getClient();

      await ensureSession(supa);

      const body = { path, question };

      if (signalId) {
        body.signal_id = signalId;
      }

      const { data, error } =
        await supa.functions.invoke(
          FUNCTION_NAME,
          { body }
        );

      if (error) throw error;

      if (!data?.success) {
        throw new Error("SIGNAL_LOOKUP_FAILED");
      }

      if (!data.found) {
        if (signalId) {
          throw new Error(
            "SIGNAL_NO_LONGER_AVAILABLE"
          );
        }

        return null;
      }

      if (
        !data.signal ||
        typeof data.signal.audio_url !== "string"
      ) {
        throw new Error(
          "INVALID_SIGNAL_RESPONSE"
        );
      }

      if (
        signalId &&
        data.signal.id !== signalId
      ) {
        throw new Error("SIGNAL_ID_CHANGED");
      }

      return data.signal;
    }

    async function downloadAudio(signal) {
      if (!signal?.audio_url) {
        throw new Error("MISSING_AUDIO_URL");
      }

      const response = await fetch(
        signal.audio_url,
        {
          cache: "no-store",
          mode: "cors"
        }
      );

      if (!response.ok) {
        throw new Error(
          "AUDIO_HTTP_" + response.status
        );
      }

      const blob = await response.blob();

      if (
        blob.size < 100 ||
        blob.size > 2 * 1024 * 1024
      ) {
        throw new Error(
          "INVALID_AUDIO_BLOB"
        );
      }

      const newURL = URL.createObjectURL(blob);
      const oldURL = localAudioURL;

      const previousPosition =
        Number.isFinite(audio.currentTime)
          ? audio.currentTime
          : 0;

      audio.pause();

      localAudioURL = newURL;
      audio.src = newURL;
      audio.load();

      if (oldURL) {
        URL.revokeObjectURL(oldURL);
      }

      if (previousPosition > 0) {
        await new Promise((resolve, reject) => {
          if (audio.readyState >= 1) {
            resolve();
            return;
          }

          function cleanup() {
            audio.removeEventListener(
              "loadedmetadata",
              onReady
            );

            audio.removeEventListener(
              "error",
              onError
            );
          }

          function onReady() {
            cleanup();
            resolve();
          }

          function onError() {
            cleanup();
            reject(
              new Error("AUDIO_LOAD_FAILED")
            );
          }

          audio.addEventListener(
            "loadedmetadata",
            onReady
          );

          audio.addEventListener(
            "error",
            onError
          );
        });

        const duration =
          Number.isFinite(audio.duration)
            ? audio.duration
            : 0;

        audio.currentTime =
          duration > 0
            ? Math.min(
                previousPosition,
                Math.max(0, duration - 0.1)
              )
            : previousPosition;
      }
    }

    async function refreshAudio() {
      if (!currentSignal) {
        throw new Error("NO_SIGNAL_SELECTED");
      }

      if (refreshing) {
        return refreshing;
      }

      refreshing = (async () => {
        const signal =
          await requestSignal(currentSignal.id);

        await downloadAudio(signal);

        rememberSignal(signal);
        prepareTranscript(signal);

        return signal;
      })();

      try {
        return await refreshing;
      } finally {
        refreshing = null;
      }
    }

    async function loadInitialAudio(signal) {
      if (loadingAudio) {
        return loadingAudio;
      }

      loadingAudio = (async () => {
        try {
          await downloadAudio(signal);
          rememberSignal(signal);
        } catch (error) {
          console.warn(
            "UXS initial audio retry:",
            error
          );

          const replacement =
            await requestSignal(signal.id);

          await downloadAudio(replacement);

          rememberSignal(replacement);
          prepareTranscript(replacement);
        }
      })();

      try {
        return await loadingAudio;
      } finally {
        loadingAudio = null;
      }
    }

    function prepareTranscript(signal) {
      const transcript =
        typeof signal?.transcript === "string"
          ? signal.transcript.trim()
          : "";

      timingWords = [];
      lastSubtitleIndex = -1;

      transcriptEl.textContent = "";
      transcriptEl.classList.remove("uxs-writing");

      if (!transcript) return;

      if (
        signal.transcript_timing_status ===
          "aligned" &&
        Array.isArray(signal.transcript_words)
      ) {
        timingWords = signal.transcript_words
          .filter(word =>
            word &&
            typeof word.word === "string" &&
            typeof word.start === "number" &&
            typeof word.end === "number" &&
            Number.isFinite(word.start) &&
            Number.isFinite(word.end) &&
            word.start >= 0 &&
            word.end > word.start
          )
          .sort((a, b) => a.start - b.start);
      }

      if (!timingWords.length) {
        transcriptEl.textContent = transcript;
      }
    }

    function updateSubtitles() {
      if (!currentSignal) return;

      const transcript =
        String(
          currentSignal.transcript || ""
        ).trim();

      if (!transcript) return;

      if (!timingWords.length) {
        if (
          transcriptEl.textContent !== transcript
        ) {
          transcriptEl.textContent = transcript;
        }

        return;
      }

      const time =
        audio.currentTime - SUBTITLE_OFFSET;

      let index = -1;

      for (
        let i = 0;
        i < timingWords.length;
        i++
      ) {
        if (time >= timingWords[i].start) {
          index = i;
        } else {
          break;
        }
      }

      if (index === lastSubtitleIndex) {
        return;
      }

      lastSubtitleIndex = index;

      if (index < 0) {
        transcriptEl.textContent = "";
        return;
      }

      const visibleWords = timingWords
        .slice(0, index + 1)
        .map(word => word.word.trim());

      transcriptEl.textContent =
        visibleWords.join(" ");

      transcriptEl.scrollTop =
        transcriptEl.scrollHeight;
    }

    function showResultIfReady() {
      if (
        !started ||
        !transitionFinished ||
        !lookupFinished
      ) {
        return;
      }

      originalQuestion =
        originalQuestion || getOriginalQuestion();

      if (!currentSignal) {
        label.textContent = "";

        questionEl.textContent =
          originalQuestion;

        setOtherQuestion("");

        playButton.style.display = "none";

        transcriptEl.classList.remove(
          "uxs-writing"
        );

        status.textContent = lookupError
          ? "NO SE PUDO RECUPERAR LA SEÑAL."
          : "TODAVÍA NO HAY OTRA VOZ DISPONIBLE.";

        footer.textContent = "";
        return;
      }

      const incomingQuestion =
        String(
          currentSignal.question || ""
        ).trim();

      label.textContent = "";

      questionEl.textContent =
        incomingQuestion || originalQuestion;

      setOtherQuestion("");

      playButton.style.display = "inline-flex";

      setPlayLabel("ESCUCHAR");

      status.textContent = "";
      footer.textContent = "";
    }

    async function findSignal() {
      const signal = await requestSignal();

      if (!signal) {
        currentSignal = null;
        return;
      }

      rememberSignal(signal);
      prepareTranscript(signal);

      emit("uxs:incoming-ready", {
        signalId: signal.id,
        connection: signal.connection
      });

      try {
        await loadInitialAudio(signal);
      } catch (error) {
        console.warn(
          "UXS audio preload:",
          error
        );
      }
    }

    function startIncoming() {
      if (started) return;

      started = true;
      transitionFinished = false;
      lookupFinished = false;
      lookupError = false;

      currentSignal = null;
      originalQuestion = getOriginalQuestion();

      timingWords = [];
      lastSubtitleIndex = -1;

      clearLocalAudio();

      root.classList.remove("uxs-share-stage");
      root.classList.add("uxs-incoming-stage");

      document.getElementById(
        "uxs-playback"
      )?.pause();

      document.getElementById(
        "uxs-vocoder-player"
      )?.pause();

      label.textContent = "";
      questionEl.textContent = originalQuestion;

      setOtherQuestion("");

      transcriptEl.textContent = "";
      transcriptEl.classList.remove("uxs-writing");

      playButton.style.display = "none";
      playButton.disabled = false;

      setPlayLabel("ESCUCHAR");

      footer.textContent = "";
      status.textContent = "BUSCANDO SEÑAL...";

      emit("uxs:incoming-started");

      findSignal()
        .catch(error => {
          console.error(
            "UXS incoming:",
            error
          );

          lookupError = true;
          currentSignal = null;
        })
        .finally(() => {
          lookupFinished = true;
          showResultIfReady();
        });
    }

    // =====================================
    // EVENTOS — COMPARTIR / NO COMPARTIR
    // =====================================

    // Si no comparte, continuar directamente.
    root.addEventListener(
      "uxs:share-declined",
      startIncoming
    );

    // Si comparte, preguntar por el correo
    // antes de activar VOICE001 V13.

    let emailGatePending = false;

    root.addEventListener(
      "uxs:signal-saved",
      event => {
        if (started || emailGatePending) return;

        const signalId = String(
          event.detail?.id || ""
        ).trim();

        const gate = window.UXSEmailGate;

        if (
          !signalId ||
          typeof gate?.show !== "function"
        ) {
          startIncoming();
          return;
        }

        emailGatePending = true;

        const continueToIncoming = () => {
          if (!emailGatePending) return;

          emailGatePending = false;
          startIncoming();
        };

        try {
          gate.show({
            signalId,
            continue: continueToIncoming
          });
        } catch (error) {
          console.error(
            "UXS email gate:",
            error
          );

          continueToIncoming();
        }
      }
    );

    root.addEventListener(
      "uxs:incoming-transition-ended",
      () => {
        transitionFinished = true;
        showResultIfReady();
      }
    );

    // =====================================
    // REPRODUCIR / PAUSAR
    // =====================================

    playButton.addEventListener(
      "click",
      async () => {
        if (!currentSignal) return;

        if (!audio.paused) {
          audio.pause();
          setPlayLabel("CONTINUAR");
          return;
        }

        playButton.disabled = true;

        try {
          if (!localAudioURL) {
            await refreshAudio();
          }

          if (
            audio.ended ||
            (
              Number.isFinite(audio.duration) &&
              audio.currentTime >=
                audio.duration - 0.1
            )
          ) {
            audio.currentTime = 0;
            lastSubtitleIndex = -1;
            transcriptEl.textContent = "";
            transcriptEl.scrollTop = 0;
          }

          await audio.play();

          setPlayLabel("PAUSAR");
          status.textContent = "";

          if (currentSignal.transcript) {
            transcriptEl.classList.add(
              "uxs-writing"
            );
          }

          updateSubtitles();

          emit("uxs:incoming-playing", {
            signalId: currentSignal.id,
            audioElement: audio
          });

        } catch (error) {
          console.error(
            "UXS incoming playback:",
            error
          );

          status.textContent =
            "NO SE PUDO REPRODUCIR LA SEÑAL.";

          setPlayLabel("ESCUCHAR");
        } finally {
          playButton.disabled = false;
        }
      }
    );

    audio.addEventListener(
      "timeupdate",
      updateSubtitles
    );

    audio.addEventListener(
      "seeked",
      () => {
        lastSubtitleIndex = -1;
        updateSubtitles();
      }
    );

    audio.addEventListener(
      "pause",
      () => {
        if (!audio.ended) {
          setPlayLabel("CONTINUAR");
        }
      }
    );

    audio.addEventListener(
      "ended",
      () => {
        setPlayLabel("ESCUCHAR OTRA VEZ");
        status.textContent = "";

        if (currentSignal?.transcript) {
          transcriptEl.classList.add(
            "uxs-writing"
          );

          transcriptEl.textContent =
            currentSignal.transcript;
        }

        emit("uxs:incoming-ended", {
          signalId: currentSignal?.id
        });
      }
    );

    window.addEventListener(
      "pagehide",
      clearLocalAudio,
      { once: true }
    );

    console.log("UXS Incoming V8 Ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
})();
